import { Box, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { TextView } from "@components";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SegmentContent from "./SegmentContent";
import { colors } from "../../../utils";
import { hexToRgb } from "../../../utils/helpers";
import _ from "lodash";
import WheelComponent from "../../WheelComponent";
import UserImage from "../../UserImage";
import SensorsIcon from "@mui/icons-material/Sensors";
import { useGetWheel } from "../../../services/queries";
import Button from "../../Button";
import DialogModal from "../../DialogModal/index";
import LinkWheelPreviewModal from "./LinkPreviewModal";
import AddIcon from "@mui/icons-material/Add";
import ShareIcon from "@mui/icons-material/Share";
import { ASSETS } from "../../../utils/config";
import { toast } from "react-toastify";
function SegmentsView({
  wheel,
  onClickLabel,
  mobileContent,
  selectedWheel,
  selectedSegment,
  onSegmentClick,
  onClickBack,
  onAddSegment,
  onLinkWheelPress,
  editorRef,
  //   onClickNext = () => {},
  //   onClickPrev = () => {},
  //   disableNext = false,
  //   disablePrev = false,
}) {
  const [chartState, setChartState] = useState([]);
  const [isSegmentLinking, setIsSegmentLinking] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [hoveredSegment, setHoveredSegment] = useState({});
  const [modalOpen, setModalOpen] = useState(false);

  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);

  const handleMouseEnter = (item) => {
    setIsHovered(true);
    setHoveredSegment(item);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    setHoveredSegment({});
  };
  useEffect(() => {
    const wheelData =
      selectedWheel && selectedWheel?.wheel_section[0]?.activity_wheel;

    const wheelUpdatedData = wheelData?.map((obj, index) => ({
      label: "blank",
      value: "1",
      isBlank: false,
      // position: 0,
      ...obj,
    }));

    const wheelUpdatedDataSorted = wheelUpdatedData?.sort(
      (a, b) => a.position - b.position
    );

    setChartState(wheelUpdatedDataSorted);
  }, [selectedWheel, isSegmentLinking]);
  const { data, isLoading } = useGetWheel(selectedWheel?.id);
  console.log(data, "DATATATATA");

  const wheelProperties = {
    wheel_image: selectedWheel?.wheel_image,
    wheel_name: selectedWheel?.wheel_name,
    author: selectedWheel?.user_profile,
    id: selectedWheel?.id,
  };

  const handleManageWheelSegment = () => {
    handleOpen();
    setIsSegmentLinking(true);
  };

  if (!selectedWheel) {
    return null;
  } else {
    return (
      <>
        <LinkWheelPreviewModal
          open={modalOpen}
          onClose={handleClose}
          wheelData={chartState}
          wheelProperties={wheelProperties}
          onConfirmPress={onLinkWheelPress}
          editorRef={editorRef}
          handleManageWheelSegment={handleManageWheelSegment}
          isSegmentLinking={isSegmentLinking}
          selectedSegment={selectedSegment}
        />

        <Stack
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          ml={1}
          onClick={onClickBack}
        >
          <ArrowBackIcon
            style={{
              cursor: "pointer",
              fontSize: "15px",
              color: colors.primary,
            }}
          />
          <TextView
            style={{
              fontSize: "14px",
              fontWeight: "400",
              color: "black",
              marginLeft: "7px",
            }}
          >
            Go back
          </TextView>
        </Stack>
        <TextView
          style={{
            fontSize: "16px",
            fontWeight: "500",
            color: "#123051",
            margin: "15px",
            marginLeft: "10px",
          }}
        >
          {selectedWheel?.wheel_name}
        </TextView>
        <Stack
          sx={{
            // border: "1px solid grey",
            borderRadius: "1vw",
            // width: "95vw",
            height: "30vh",
            // overflowY: "auto",

            marginLeft: "0.5vw",
            padding: "5px",
            mb: 2,
          }}
          display={"flex"}
          flexDirection={"row"}
          // justifyContent={"space-between"}
        >
          <Stack style={{ flex: 1 }}>
            <SensorsIcon style={{ color: "#FF7A5C" }} />
            <WheelComponent
              userData={{
                id: Math.random() * 10,
                url: selectedWheel?.wheel_image,
              }}
              maxSelectedArcs={0}
              arcThickness={-25}
              chartData={chartState}
              containerDivStyle={{
                height: "20vh",
                width: "10vw",
                marginTop: "-4.5vh",
                // marginLeft: "-3.5vw",
                // marginRight: "-4vw",
              }}
            ></WheelComponent>
            <Stack
              style={{ alignSelf: "center" }}
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"flex-start"}
              alignItems={"center"}
              ml={-1}
              mr={1}
            >
              <UserImage
                size={16}
                image={selectedWheel?.user_profile?.profile_image}
              />
              <TextView
                style={{
                  fontSize: "12px",
                  fontWeight: "500",
                  color: "#565556",
                  marginLeft: "4px",
                  textTransform: "capitalize",
                  display: "-webkit-box", // Use the webkit box model for the container
                  WebkitBoxOrient: "vertical", // Set the box orientation to vertical
                  WebkitLineClamp: 1, // Limit the content to 2 lines
                  overflow: "hidden", // Hide the overflow content
                  textOverflow: "ellipsis", // Add an ellipsis to any overflow text
                }}
              >
                {selectedWheel?.user_profile?.first_name}
              </TextView>
            </Stack>
            <div style={{ marginTop: 10,  }}>
              <div
                style={{
                  width: "107px",
                  height: "36px",
                  padding: "6px 18px 6px 18px",
                  gap: "8px",
                  borderRadius: 4,
                  border: "0.5px 0px 0px 0px",
                  opacity: "0px",
                  backgroundColor: "#F6F7F9",
                  cursor: "pointer",
                  alignSelf:"center",
                  marginLeft:15
                }}
                onClick={(e) => {
                  if (editorRef.current) {
                    handleOpen();
                    setIsSegmentLinking(false);
                  } else {
                    toast.error("Please open a segment first");
                  }
                }}
              >
                <span
                  style={{
                    fontFamily: "Open Sans",
                    fontSize: "12px",
                    fontWeight: 400,
                    lineHeight: "20px",
                    textAlign: "center",
                    color: "#123051",
                  }}
                >
                  Link Wheel
                </span>
              </div>
            </div>
          </Stack>
          <Stack
            pl={1.5}
            py={2}
            pr={0.5}
            style={{
              background: "#F6F7F9",
              border: "2px solid #E1E1E1",
              //   padding: "10px",
              overflowY: "auto",
              borderRadius: "4px",
              flex: 2,
              // width: "75%",
            }}
          >
            <TextView
              style={{
                fontSize: "16px",
                fontWeight: "500",
                color: "#565556",
                marginBottom: "5px",
              }}
            >
              Segments
            </TextView>
            {data?.data?.wheel_section?.[0]?.activity_wheel
              ?.sort((a, b) => a.position - b.position)
              ?.map((item) => {
                const [r, g, b] = hexToRgb(item?.color);
                const bgColor = `rgba(${r},${g},${b},0.2)`;
                return (
                  <Stack
                    onMouseEnter={() =>
                      _.isEmpty(selectedSegment) && handleMouseEnter(item)
                    }
                    onMouseLeave={() =>
                      _.isEmpty(selectedSegment) && handleMouseLeave()
                    }
                    onClick={() => {
                      setHoveredSegment({});
                      onSegmentClick(item);
                    }}
                    display={"flex"}
                    flexDirection={"row"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    sx={{
                      border:
                        item === selectedSegment
                          ? "1px solid black"
                          : `0.75px solid ${item?.color}`,
                      borderRadius: "5px",
                      backgroundColor: bgColor,
                      pl: 1.5,
                      mb: 0.6,
                      py: 0.75,
                      cursor: "pointer",
                      //   height: "20vh",
                    }}
                  >
                    <Box>
                      <Stack
                        display={"flex"}
                        flexDirection={"row"}
                        justifyContent={"space-evenly"}
                        alignItems={"center"}
                      >
                        <Box
                          sx={{
                            backgroundColor: item?.color,
                            borderRadius: "50%",
                            height: "8px",
                            width: "8px",
                            mr: 1,
                          }}
                        ></Box>
                        <TextView
                          style={{
                            fontSize: "12px",
                            // color: item === mobileContent[0] ? "#0f0e0f" : "#777777",
                            fontWeight: 400,
                            color: colors.darkGrey,
                          }}
                        >
                          {item?.title}
                        </TextView>
                      </Stack>
                    </Box>

                    {/* Start Segment Linking Icons */}
                    <Box>
                      <Stack
                        display={"flex"}
                        flexDirection={"row"}
                        justifyContent={"space-evenly"}
                        alignItems={"center"}
                      >
                        <img
                          src={ASSETS.shareSegmentIcon}
                          // onClick={handleManageWheelSegment}
                          alt="shareSegmentIcon"
                          width="16"
                          height="16"
                        />
                        <AddIcon
                          style={{ color: colors.darkGrey, marginLeft: "2px" }}
                        />
                      </Stack>
                    </Box>
                    {/* End Segment Linking Icons */}
                  </Stack>
                );
              })}
          </Stack>
        </Stack>
        {/* <Stack
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"flex-end"}
          alignItems={"center"}
        >
          <ArrowCircleLeftOutlinedIcon
            style={{ fontSize: "30px", opacity: disablePrev ? 0.5 : 1 }}
            onClick={() => (disablePrev ? null : onClickPrev())}
          />
          <ArrowCircleRightOutlinedIcon
            style={{ fontSize: "30px", opacity: disableNext ? 0.5 : 1 }}
            onClick={() => (disableNext ? null : onClickNext())}
          />
        </Stack> */}
        {_.isEmpty(selectedSegment) ? null : (
          <SegmentContent
            content={selectedSegment}
            showLabels={true}
            onAddSegment={onAddSegment}
            // handleManageWheelSegment={handleManageWheelSegment}
          />
        )}
        {!_.isEmpty(hoveredSegment) ? (
          <SegmentContent
            content={hoveredSegment}
            showLabels={true}
            onAddSegment={onAddSegment}
            // handleManageWheelSegment={handleManageWheelSegment}
          />
        ) : null}
      </>
    );
  }
}

export default SegmentsView;
